// extracted by mini-css-extract-plugin
export default {"inventory-tab":"inventory-tab","prod-list-scrolled":"prod-list-scrolled","pending-tabs":"pending-tabs"};